import dayjs from "dayjs";
import { EntityTypes } from "@vzbl/integrations";
import { useApplicationContext } from "src/hooks/useApplication";
import { IntegrationIcon } from "src/components/IntegrationIcon";
import { useEntityContext } from "../useEntityContext";
import { TabbedWork } from "../components/TabbedWork";
import { useWorkTabs } from "../components/worktabs";
import { History, HistoryComponent } from "../History";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { ActionCard } from "./components/ActionCard";
import { SummaryTag } from "./components/Tags";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { toHeaderAttributes } from "./components/HeaderAttributes";
import { EntityTabs } from "./components/EntityTabs";
import { SentencesList } from "./components/SentencesList";
import { Insights } from "../Insights";

export const BranchEntity = () => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const properties = context.dataRef.current.entity.properties;
  const entityType = context.dataRef.current.entity.labels[0];
  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel
          label={properties.branch}
          entity={context.dataRef.current.entity}
          attributes={toHeaderAttributes({
            orgId,
            context,
            entityType,
            attributes: [
              {
                name: "created-at",
                text: dayjs(new Date(properties.createdAt)).format(
                  "MMM D, YYYY h:mm A	"
                ),
              },
              { name: "repository", text: properties.repository },
              { name: "status", text: properties.status },
            ],
          })}
          icon={
            <IntegrationIcon source={properties.integration} size="large" />
          }
        />
      }
      summaryPanel={<SummaryPanel title={properties.name} />}
      insightsPanel={
        <InsightsPanel
          cards={[
            properties.vzblValueStatement && (
              <ActionCard
                key="value-statement"
                badge={<SummaryTag />}
                label="Value Statement"
                value={
                  <SentencesList showNa data={properties.vzblValueStatement} />
                }
              />
            ),
          ].filter(Boolean)}
        />
      }
    >
      <EntityTabs
        propertiesSkipList={[
          "vzblValueStatement",
          "repository",
          "status",
          "name",
          "createdAt",
        ]}
        entity={context.dataRef.current.entity}
        tabs={[
          {
            key: "overview",
            id: "overview",
            label: "Overview",
            children: <Insights entity={context.dataRef.current.entity} />,
          },
          {
            key: "work",
            id: "work",
            label: "Work",
            children: (
              <TabbedWork
                items={useWorkTabs(orgId, properties.uuid, [
                  { entityTypes: EntityTypes.Issue },
                  { entityTypes: EntityTypes.PullRequest },
                  { entityTypes: EntityTypes.Commit },
                  {
                    entityTypes: EntityTypes.PullRequestReviewComment,
                    label: "Comments",
                  },
                  { entityTypes: EntityTypes.Release },
                  {
                    entityTypes: EntityTypes.CicdPipeline,
                    label: "Deployments",
                  },
                ])}
              />
            ),
          },
          {
            key: "history",
            id: "history",
            label: "History",
            children: (
              <History>
                <HistoryComponent />
              </History>
            ),
          },
        ]}
      />
    </EntityScreen>
  );
};
